import React, { useMemo, useState } from 'react'
import { ElementWithTooltip } from '../../../element-with/element-with-tooltip/ElementWithTooltip'
import { ButtonGroupStyled, BuySellButtonStyled, WidgetMainContainerStyled } from '../../styled_v2'
import { PreOrderDTO } from '../../types'
import { NewTickerDO } from '../types'
import BSChart from './BSChart'
import BSEvents from './BSEvents'
import BSInfo from './BSInfo'
import { WidgetsCollectionWrapper } from './styled'

export interface AcuityWidgetsDO {
    ticker: NewTickerDO
    widgetExpanded: boolean
    setWidgetExpanded: Function
    acuityCode: PreOrderDTO['acuityCode']
}

export type AcuityWidgetType = 'chart' | 'info' | 'events'
export default function Widgets({ ticker, widgetExpanded, setWidgetExpanded, acuityCode }: AcuityWidgetsDO) {
    const [className] = useState('AcuityWidgets-' + new Date().getTime())
    const chart: React.JSX.Element = <BSChart acuityCode={acuityCode} key={'chart-' + ticker?.displayTicker} ticker={ticker} />
    const info: React.JSX.Element = <BSInfo acuityCode={acuityCode} key={'info-' + ticker?.displayTicker} ticker={ticker} />
    const events: React.JSX.Element = <BSEvents acuityCode={acuityCode} key={'events-' + ticker?.displayTicker} ticker={ticker} />

    const showWidgets: boolean = typeof acuityCode !== 'undefined'
    const [currentWidgetType, setCurrentWidgetType] = useState<AcuityWidgetType>('chart')
    // useMemo not working as expected...
    const widgetMap = useMemo(() => {
        return { chart, info, events }
    }, [ticker])

    const currentWidget = widgetMap[currentWidgetType]

    return (
        <WidgetMainContainerStyled>
            <div className="row g-0">
                {showWidgets && (
                    <WidgetsCollectionWrapper>
                        <ButtonGroupStyled className="row g-0 row-cols-3 d-flex justify-content-center">
                            <BuySellButtonStyled
                                onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => setCurrentWidgetType('chart')}
                                active={currentWidgetType === 'chart'}
                            >
                                Chart
                            </BuySellButtonStyled>
                            <BuySellButtonStyled
                                onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => setCurrentWidgetType('info')}
                                active={currentWidgetType === 'info'}
                            >
                                Info
                            </BuySellButtonStyled>
                            <BuySellButtonStyled
                                onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => setCurrentWidgetType('events')}
                                active={currentWidgetType === 'events'}
                            >
                                Events
                            </BuySellButtonStyled>
                        </ButtonGroupStyled>
                    </WidgetsCollectionWrapper>
                )}
                <div className="col-4 ms-auto mb-3" style={{ width: 'auto' }}>
                    <ButtonGroupStyled className="row g-0 row-cols-2 d-flex justify-content-center" style={{ maxWidth: '100px' }}>
                        <BuySellButtonStyled
                            onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => setWidgetExpanded(true)}
                            active={widgetExpanded}
                        >
                            <ElementWithTooltip
                                element={<i className="fa-solid fa-arrows-left-right-to-line" />}
                                tooltip={<span>{widgetExpanded ? 'Expanded' : 'Expand'}</span>}
                            />
                        </BuySellButtonStyled>
                        <BuySellButtonStyled
                            onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => setWidgetExpanded(false)}
                            active={!widgetExpanded}
                        >
                            <ElementWithTooltip
                                element={<i className="fa-solid fa-minimize"></i>}
                                tooltip={<span>{widgetExpanded ? 'Collapse' : 'Collapsed'}</span>}
                            />
                        </BuySellButtonStyled>
                    </ButtonGroupStyled>
                </div>
            </div>

            <div>
                {showWidgets && currentWidget}
                {!showWidgets && (
                    <div className={'text-center mt-3'}>
                        <i className="fa-solid fa-chart-line fa-5x"></i>
                        <p className="lead mt-3">coming soon...</p>
                        <br />
                        <i className="fa-solid fa-circle-info fa-5x"></i>
                        <p className="lead mt-3">coming soon...</p>
                        <br />
                        <i className="fa-solid fa-calendar-days fa-5x"></i>
                        <p className="lead mt-3">coming soon...</p>
                    </div>
                )}
            </div>
        </WidgetMainContainerStyled>
    )
}
